import React from "react"
import { Container, Inner } from "./client-hero.styles"

export default ({ children }) => (
  <Container>
    <Inner>{children}</Inner>
  </Container>
)
